import { get, post, put, Delete } from "../axios";

// 文件上传-查看
export const systemUploadView = (params) => get("/web/system/upload/view");

// 文件上传-修改
export const systemUploadUpdate = (params) =>
  put("/web/system/upload/update", params);
